import { render } from "./UplChart.vue?vue&type=template&id=61733a80&scoped=true"
import script from "./UplChart.vue?vue&type=script&lang=ts"
export * from "./UplChart.vue?vue&type=script&lang=ts"

import "./UplChart.vue?vue&type=style&index=0&id=61733a80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61733a80"

export default script